import React from "react";
import { Field } from "formik";
import { TextField, CheckboxWithLabel } from "formik-material-ui";
// import { Debug } from './Debug';
import { FormControlLabel, Grid, TextEditor, EditorState, Typography, DatePicker, ReactEditor } from "../../..";
import { makeStyles } from "@material-ui/core/styles";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "no-wrap",
      padding: "20px"
    },
    form: {
      display: "flex"
    },
    repeat: {
      margin: 0
    },
    service: {
      width: "100%"
    },
    mr30: {
      "margin-right": "30px"
    },
    actions: {
      display: "flex",
      padding: "30px",
      "justify-content": "flex-end"
    },
    repeatField: {
      width: "50%",
      "margin-right": "20px"
    },
    flex: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  };
});

var BasicInfoForm = function BasicInfoForm(_ref) {
  var values = _ref.values,
      mode = _ref.mode,
      franchise = _ref.franchise,
      translation = _ref.translation,
      setFieldValue = _ref.setFieldValue;
  // console.log("BasicInfoForm values", values);
  var classes = useStyles();

  var _handleEditorChange = function handleEditorChange(_ref2, editorState, aux) {
    var field = _ref2.field,
        form = _ref2.form;
    // console.log("handleEditorChange", editorState, aux);
    // console.log("BasicInfoForm values", values);
    // console.log("BasicInfoForm field", field);
    form.setFieldValue(field.name, editorState);
  };

  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 6,
    className: classes.editor
  }, /*#__PURE__*/React.createElement(Field, {
    name: "details",
    label: "Detalles"
  }, function (props) {
    // console.log("BasicInfoForm field", props);
    return /*#__PURE__*/React.createElement(ReactEditor, {
      name: props.field.name,
      editorState: props.field.value ? props.field.value : EditorState.createEmpty(),
      mode: mode,
      handleEditorChange: function handleEditorChange(editorSate, aux) {
        return _handleEditorChange(props, editorSate, aux);
      }
    }) //    <TextEditor
    //   value={field.value}
    //   mode={mode}
    //   onChange={field.onChange(field.name)}
    // />
    ;
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, translation ? translation.inputs.deadline : "Fecha Límite"), franchise ? /*#__PURE__*/React.createElement(Field, {
    "data-cy": "deadline",
    name: "deadline",
    label: translation ? translation.inputs.deadline : "Fecha límite",
    className: classes.mr30,
    component: DatePicker,
    time: true,
    format: "DD/MM/YYYY HH:mm",
    value: values.deadline,
    disabled: mode === "view"
  }) : /*#__PURE__*/React.createElement(Field, {
    name: "daysToDeadline",
    fullWidth: true,
    type: "number",
    label: "Plazo en D\xEDas",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    helperText: "\xBFCu\xE1ntos d\xEDas antes de la ejecuci\xF3n tiene que reailzarse esta tarea?",
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, translation ? translation.titles.dates : "Tipo de tarea"), /*#__PURE__*/React.createElement(FormControlLabel, {
    className: classes.repeat,
    control: /*#__PURE__*/React.createElement(Field, {
      label: "Tarea recurrente",
      name: "repeat",
      component: CheckboxWithLabel,
      color: "primary",
      disabled: mode === "view"
    }),
    label: "Tarea Recurrente"
  }), values.repeat && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, translation ? translation.titles.dates : "¿Cada cuantos días se repite esta tarea?")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 6,
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Field, {
    name: "repeatsDays",
    label: "Se repite cada ... d\xEDas",
    component: TextField,
    type: "number",
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 6,
    className: classes.flex
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    className: classes.service,
    disabled: values.times,
    control: /*#__PURE__*/React.createElement(Field, {
      name: "untilEOS",
      component: CheckboxWithLabel,
      color: "primary",
      disabled: mode === "view"
    }),
    label: translation ? translation.checkboxes.times : "Hasta el final de la fase o servicio"
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    className: classes.service,
    control: /*#__PURE__*/React.createElement(Field, {
      disabled: values.untilEOS || mode === "view",
      name: "times",
      component: CheckboxWithLabel,
      color: "primary"
    }),
    label: translation ? translation.checkboxes.untilEOS : "Un número determinado de veces"
  }), values.times && /*#__PURE__*/React.createElement(Field, {
    name: "maxRepeats",
    disabled: values.untilEOS || mode === "view",
    className: classes.service,
    label: "N\xFAmero de veces determinado",
    component: TextField,
    type: "number",
    margin: "normal",
    variant: "outlined",
    helperText: "\xBFCu\xE1ntas veces se repite?"
  })))));
};

BasicInfoForm.defaultProps = {
  mode: "add"
};
export { BasicInfoForm };